export default function (state, val) {
    for (let k in val) {
        state.load[k] = val[k];
    }
}